import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { WritableComputedRef } from 'vue';
import { B2CFindPersonalOfferTileModel } from '@/types/B2CcontentServerContract';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import FindPersonalOffer from '@/b2c/offers/ui/FindPersonalOffer.vue';
import { QueryKeys } from '@/shared/config/route-query.config';
import { useRouteQuery } from '@/core/browser/route-query.composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'B2CFindPersonalOfferTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content: B2CFindPersonalOfferTileModel,
}



const id: WritableComputedRef<string | undefined> = useRouteQuery<string>(QueryKeys.Id);
const addToBasket: WritableComputedRef<boolean | undefined> = useRouteQuery<boolean>(QueryKeys.AddToBasket);
const autoFindId = props.content.autoSubmit ? id.value : '';
const autoAddtoBasket = addToBasket.value;
id.value = undefined;
addToBasket.value = undefined;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createVNode(FindPersonalOffer, {
        class: "mx-auto max-w-500",
        "auto-find-id": _unref(autoFindId),
        "add-to-basket": _unref(autoAddtoBasket),
        "details-url": __props.content.detailUrl
      }, null, 8, ["auto-find-id", "add-to-basket", "details-url"])
    ]),
    _: 1
  }))
}
}

})